import { useState } from 'react';
import ConfirmModal, { ConfirmModalProps } from '@sdk/components/ui/confirmModal/ConfirmModal';
import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ModalState } from '@sdk/components/ui/modal/useModalState';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import TextField from '@sdk/components/forms/TextField';
import Row from '@sdk/components/ui/spacing/Row';

import AnnouncementRed from '@web/assets/svg/Icons/32/announcement-red.svg';

type Props = {
  modalState: ModalState;
  onSubmit: () => Promise<any>;
  title: string;
  description: string;
  textToRetype?: string;
  primaryButtonText?: string;
} & Partial<ConfirmModalProps>;

export const DeleteConfirmModal = ({
  modalState,
  onSubmit,
  title,
  description,
  textToRetype,
  primaryButtonText,
  ...restProps
}: Props) => {
  const [confirmText, setConfirmText] = useState('');

  return modalState.isVisible ? (
    <ConfirmModal
      fullScreen
      titleText={title}
      titleThemeColor={ThemeColorType.danger}
      titleIcon={<AnnouncementRed />}
      primaryButtonText={primaryButtonText || gettext('Yes')}
      primaryButtonType={ButtonType.danger}
      primaryButtonDisabled={!!textToRetype && confirmText !== textToRetype}
      secondaryButtonText={gettext('Cancel')}
      buttonsPadding={0}
      dismiss={() => {
        modalState.close();
      }}
      onPrimaryClick={() => onSubmit()}
      {...restProps}>
      <Text14 themeColor={ThemeColorType.gray}>{description}</Text14>
      {!!textToRetype && (
        <>
          <Row mTop={10} mBottom={10}>
            <Text14>{gettext('Type')}</Text14>
            <Text14 semiBold>&nbsp;{textToRetype}&nbsp;</Text14>
            <Text14>{gettext('to confirm:')}</Text14>
          </Row>
          <TextField
            value={confirmText}
            onChange={({ target: { value } }): void => {
              setConfirmText(value);
            }}
            skipErrorMessage
          />
        </>
      )}
    </ConfirmModal>
  ) : null;
};
